import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { connect } from 'react-redux';
import MaterialsRequestedModal from '../materialsRequestedModal';
import { updatePhaseTask } from 'actionCreators/phase';
import { requestPhaseItems } from 'actionCreators/phase_items';
import PhaseTask from './phase_task';

export class MaterialsRequested extends PhaseTask {

  onClick = () => {
    if (this.props.task.status === 'complete') this.toggleStatus();
    else this.setState({ modalActive: true });
  }

  renderChildren = () => {
    const { phase, task, user: { name, role }, chargebackLineItems } = this.props;
    const chargebackItems = chargebackLineItems.filter(cb => cb.id > 0);
    const chargebackPresent = chargebackItems.length > 0;
    return (<MaterialsRequestedModal
      phase={phase}
      userName={name}
      role={role}
      task={task}
      chargebackPresent={chargebackPresent}
      active={this.state.modalActive}
      completeTask={this.completeTask}
      onClose={this.handleClose}
    />);
  }
}

MaterialsRequested.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

export const workorder_materials_requested = connect(() => state => ({
  user: state.user,
  chargebackLineItems: state.phase.contractorChargebackItems.items,
}), { updatePhaseTask, requestPhaseItems })(MaterialsRequested);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/materials_requested.jsx